// import React, { useEffect, useState } from 'react';
// import { styled } from '@mui/system';

// const PopperContainer = styled('div')({
//   width: '100%',
//   height: '100vh',
//   pointerEvents: 'none',
//   zIndex: 99,
//   position: 'fixed',
//   top: 0,
//   left: 0,
//   overflow: 'hidden',
// });

// const PopperPiece = styled('div')({
//   position: 'absolute',
//   top: '-50px',
//   width: '6px', // Slightly wider for better parallelogram effect
//   height: '20px', // Increased height for visibility
//   transform: 'skew(-20deg)', // Skewing to create parallelogram effect
//   animationName: 'popper',
//   animationTimingFunction: 'linear',
//   animationIterationCount: 'infinite',
//   '@keyframes popper': {
//     '0%': { transform: 'translateY(-20px) rotate(0deg) skew(-20deg)' },
//     '100%': { transform: 'translateY(calc(100vh + 20px)) rotate(160deg) skew(-20deg)' },
//   },
// });

// const colors = ['#ce1d1d', '#6f39b1', '#05ab6d', '#f5d86b', '#cd0a85', '#1163bf'];

// const PartyPopperEffect = () => {
//   const [pieces, setPieces] = useState([]);

//   const createConfetti = () => {
//     const numberOfPieces = 200; // Reduced for better effect
//     let piecesArray = [];
//     for (let i = 0; i < numberOfPieces; i++) {
//       piecesArray.push({
//         id: i,
//         left: `${Math.random() * 100}vw`,
//         backgroundColor: colors[Math.floor(Math.random() * colors.length)],
//         animationDuration: `${Math.random() * 3 + 2}s`,
//         animationDelay: `${Math.random() * 3}s`,
//       });
//     }
//     setPieces(piecesArray);
//   };

//   useEffect(() => {
//     createConfetti();
//     const intervalId = setInterval(createConfetti, 5000);
//     return () => clearInterval(intervalId);
//   }, []);

//   return (
//     <PopperContainer>
//       {pieces.map((piece) => (
//         <PopperPiece
//           key={piece.id}
//           style={{
//             left: piece.left,
//             backgroundColor: piece.backgroundColor,
//             animationDuration: piece.animationDuration,
//             animationDelay: piece.animationDelay,
//           }}
//         />
//       ))}
//     </PopperContainer>
//   );
// };

// export default PartyPopperEffect;

import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import snowflake from "../images/snowflake.svg";

const SnowContainer = styled("div")({
  width: "100%",
  height: "100vh",
  pointerEvents: "none",
  zIndex: 99,
  position: "fixed",
  top: 0,
  left: 0,
  overflow: "hidden",
});

const Snowflake = styled("img")({
  position: "absolute",
  width: "14px",
  height: "14px",
  animationTimingFunction: "linear",
  animationIterationCount: "infinite",
});

const colors = [
  "invert(35%) sepia(100%) saturate(7486%) hue-rotate(340deg) brightness(100%) contrast(98%)",
  "invert(21%) sepia(99%) saturate(7450%) hue-rotate(250deg) brightness(89%) contrast(95%)",
  "invert(42%) sepia(99%) saturate(2440%) hue-rotate(150deg) brightness(97%) contrast(90%)",
  "invert(84%) sepia(67%) saturate(7450%) hue-rotate(45deg) brightness(95%) contrast(90%)",
  "invert(28%) sepia(99%) saturate(5000%) hue-rotate(315deg) brightness(93%) contrast(100%)",
  "invert(30%) sepia(98%) saturate(3000%) hue-rotate(200deg) brightness(90%) contrast(95%)",
];

const SnowfallEffect = () => {
  const [flakes, setFlakes] = useState([]);

  const createSnowflakes = () => {
    const numberOfFlakes = 250;
    let flakeArray = [];
    for (let i = 0; i < numberOfFlakes; i++) {
      flakeArray.push({
        id: i,
        left: `${Math.random() * 100}vw`,
        top: `${-10 - Math.random() * 20}vh`,
        filter: colors[Math.floor(Math.random() * colors.length)],
        animationDuration: `${Math.random() * 5 + 3}s`,
        animationDelay: `${Math.random() * 2}s`,
      });
    }
    setFlakes(flakeArray);
  };

  useEffect(() => {
    createSnowflakes();
    const intervalId = setInterval(createSnowflakes, 5000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <SnowContainer>
      {flakes.map((flake) => (
        <Snowflake
          key={flake.id}
          src={snowflake}
          alt="Snowflake"
          style={{
            left: flake.left,
            top: flake.top,
            filter: flake.filter,
            animationDuration: flake.animationDuration,
            animationDelay: flake.animationDelay,
            animationName: "falling-snow",
          }}
        />
      ))}

      <style>
        {`
          @keyframes falling-snow {
            0% { transform: translateY(0); opacity: 1; }
            90% { transform: translateY(100vh); opacity: 1; }
            100% { transform: translateY(110vh); opacity: 0; }
          }
        `}
      </style>
    </SnowContainer>
  );
};

export default SnowfallEffect;
